import "core-js/modules/es.array.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6b3530a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "center-content"
};
const _hoisted_2 = {
  class: "margin-align-center",
  slot: "end"
};
import { useField } from 'vee-validate';
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import AppDatetime from '@/components/AppDatetime.vue';
import AppDatetimePopover from '@/components/AppDatetimePopover.vue';
import AppIconTooltip from '@/components/AppIconTooltip.vue';
import { deepEquals } from '@/utils/objects';
import { humanizeCamel } from '@/utils/strings';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppFormFieldItem',
  props: {
    type: {},
    field: {},
    label: {},
    hideLabel: {
      type: Boolean
    },
    placeholder: {},
    required: {
      type: Boolean
    },
    helpText: {},
    tooltipText: {},
    lines: {},
    hideErrorMsg: {
      type: Boolean
    },
    keepValueOnUnmount: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    min: {},
    max: {},
    stringType: {},
    maxlength: {},
    spellcheck: {
      type: Boolean
    },
    interface: {},
    interfaceOptions: {},
    multiple: {
      type: Boolean
    },
    options: {},
    optionLabels: {},
    opts: {}
  },
  setup(__props) {
    const props = __props;
    //eslint-disable-next-line
    const {
      errorMessage,
      value
    } = useField(() => props.field, undefined, {
      keepValueOnUnmount: props.keepValueOnUnmount
    });
    const {
      t
    } = useI18n({
      messages: {
        en: {
          cancelLabel: 'Cancel',
          okLabel: 'OK'
        },
        es: {
          cancelLabel: 'Cancelar',
          okLabel: 'Aceptar'
        }
      }
    });
    const labelPosition = computed(() => {
      switch (props.type) {
        case 'toggle':
          return undefined;
        case 'checkbox':
          return undefined;
        case 'datetime':
          return undefined;
        case 'select':
          return 'floating';
        default:
          return 'stacked';
      }
    });
    // number-input
    function handleNumberIonInputChange(event) {
      const {
        detail
      } = event;
      value.value = detail.value ? +detail.value : undefined;
    }
    // select
    const useFullWidthAlert = computed(() => {
      var _props$optionLabels;
      return (_props$optionLabels = props.optionLabels) === null || _props$optionLabels === void 0 ? void 0 : _props$optionLabels.some(label => label.length > 20);
    });
    function safelyHandleIonSelectChange(event) {
      // Break reactivity loop between vee-validate state update and ionChange events
      if (value.value === event.detail.value) return;
      value.value = event.detail.value;
    }
    // datetime
    function safelyHandleDatetimeChange(event) {
      // Break reactivity loop between vee-validate state update and ionChange events
      if (value.value === event) return;
      value.value = event;
    }
    watch(() => props.options, (before, after) => {
      if (!Array.isArray(value.value) || deepEquals(before, after)) return;
      // Value is multi-select, filter out selections that are no longer in options
      value.value = value.value.filter(selection => {
        return props.options && [...props.options].includes(selection);
      });
    });
    return (_ctx, _cache) => {
      var _props$opts, _props$opts2;
      const _component_ion_label = _resolveComponent("ion-label");
      const _component_ion_input = _resolveComponent("ion-input");
      const _component_ion_textarea = _resolveComponent("ion-textarea");
      const _component_ion_segment_button = _resolveComponent("ion-segment-button");
      const _component_ion_segment = _resolveComponent("ion-segment");
      const _component_ion_select_option = _resolveComponent("ion-select-option");
      const _component_ion_select = _resolveComponent("ion-select");
      const _component_ion_toggle = _resolveComponent("ion-toggle");
      const _component_ion_checkbox = _resolveComponent("ion-checkbox");
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_text = _resolveComponent("ion-text");
      const _component_ion_item = _resolveComponent("ion-item");
      return _openBlock(), _createBlock(_component_ion_item, _mergeProps({
        lines: _ctx.lines
      }, {
        id: `app-form-field-item-${_ctx.field}`,
        "data-vv-field": _ctx.field,
        button: _ctx.type === 'datetime' && !((_props$opts = props.opts) !== null && _props$opts !== void 0 && _props$opts.inline),
        class: {
          'ion-item-no-padding ion-no-padding': _ctx.type === 'segment',
          'deactivate-item': _ctx.type === 'datetime' && ((_props$opts2 = props.opts) === null || _props$opts2 === void 0 ? void 0 : _props$opts2.inline)
        },
        disabled: _ctx.disabled
      }), {
        default: _withCtx(() => {
          var _ctx$stringType, _ctx$placeholder, _ctx$placeholder2, _ctx$interfaceOptions, _props$opts3;
          return [_renderSlot(_ctx.$slots, "start"), !_ctx.hideLabel && _ctx.type !== 'segment' ? (_openBlock(), _createBlock(_component_ion_label, {
            key: 0,
            position: labelPosition.value,
            class: _normalizeClass([{
              required: _ctx.required
            }, 'ion-text-wrap'])
          }, {
            default: _withCtx(() => {
              var _ctx$label;
              return [_createTextVNode(_toDisplayString((_ctx$label = _ctx.label) !== null && _ctx$label !== void 0 ? _ctx$label : _unref(humanizeCamel)(_ctx.field)), 1)];
            }),
            _: 1
          }, 8, ["position", "class"])) : _createCommentVNode("", true), _ctx.type === 'string-input' ? (_openBlock(), _createBlock(_component_ion_input, _mergeProps({
            key: 1,
            modelValue: _unref(value),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(value) ? value.value = $event : null),
            type: (_ctx$stringType = _ctx.stringType) !== null && _ctx$stringType !== void 0 ? _ctx$stringType : 'text'
          }, {
            placeholder: (_ctx$placeholder = _ctx.placeholder) !== null && _ctx$placeholder !== void 0 ? _ctx$placeholder : 'Aa',
            maxlength: _ctx.maxlength,
            spellcheck: _ctx.spellcheck
          }), null, 16, ["modelValue", "type"])) : _ctx.type === 'number-input' ? (_openBlock(), _createBlock(_component_ion_input, _mergeProps({
            key: 2,
            value: _unref(value) !== undefined ? +_unref(value) : undefined,
            type: "number"
          }, {
            placeholder: _ctx.placeholder,
            min: _ctx.min,
            max: _ctx.max
          }, {
            onIonChange: handleNumberIonInputChange
          }), null, 16, ["value"])) : _ctx.type === 'textarea' ? (_openBlock(), _createBlock(_component_ion_textarea, _mergeProps({
            key: 3,
            modelValue: _unref(value),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(value) ? value.value = $event : null)
          }, {
            placeholder: (_ctx$placeholder2 = _ctx.placeholder) !== null && _ctx$placeholder2 !== void 0 ? _ctx$placeholder2 : 'Aa',
            maxlength: _ctx.maxlength,
            spellcheck: _ctx.spellcheck
          }, {
            "auto-grow": ""
          }), null, 16, ["modelValue"])) : _ctx.type === 'segment' ? (_openBlock(), _createBlock(_component_ion_segment, {
            key: 4,
            modelValue: _unref(value),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(value) ? value.value = $event : null),
            disabled: _ctx.options === undefined || _ctx.options.length === 0,
            class: "ion-no-margin default-background"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
              return _openBlock(), _createBlock(_component_ion_segment_button, {
                key: option,
                value: String(option)
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_label, null, {
                  default: _withCtx(() => {
                    var _ctx$optionLabels;
                    return [_createTextVNode(_toDisplayString(((_ctx$optionLabels = _ctx.optionLabels) === null || _ctx$optionLabels === void 0 ? void 0 : _ctx$optionLabels[i]) || _unref(humanizeCamel)(option.toString())), 1)];
                  }),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "disabled"])) : _ctx.type === 'select' ? (_openBlock(), _createBlock(_component_ion_select, _mergeProps({
            key: 5
          }, {
            multiple: _ctx.multiple,
            interface: _ctx.interface,
            interfaceOptions: _ctx.interfaceOptions,
            value: _unref(value),
            placeholder: _ctx.placeholder
          }, {
            style: (_ctx$interfaceOptions = _ctx.interfaceOptions) !== null && _ctx$interfaceOptions !== void 0 && _ctx$interfaceOptions.cover ? {
              width: '100%'
            } : {},
            disabled: _ctx.options === undefined || _ctx.options.length === 0,
            "cancel-text": _unref(t)('cancelLabel'),
            "ok-text": _unref(t)('okLabel'),
            interfaceOptions: {
              cssClass: useFullWidthAlert.value ? 'full-width-alert' : ''
            },
            class: "ion-text-wrap",
            onIonChange: safelyHandleIonSelectChange
          }), {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
              return _openBlock(), _createBlock(_component_ion_select_option, {
                key: option,
                value: option
              }, {
                default: _withCtx(() => {
                  var _ctx$optionLabels2;
                  return [_createTextVNode(_toDisplayString(((_ctx$optionLabels2 = _ctx.optionLabels) === null || _ctx$optionLabels2 === void 0 ? void 0 : _ctx$optionLabels2[i]) || _unref(humanizeCamel)(option.toString())), 1)];
                }),
                _: 2
              }, 1032, ["value"]);
            }), 128))]),
            _: 1
          }, 16, ["style", "disabled", "cancel-text", "ok-text", "interfaceOptions"])) : _ctx.type === 'toggle' ? (_openBlock(), _createBlock(_component_ion_toggle, {
            key: 6,
            checked: Boolean(_unref(value)),
            onIonChange: _cache[3] || (_cache[3] = e => value.value = e.detail.checked),
            slot: "end",
            style: _normalizeStyle(_ctx.hideLabel ? {
              paddingLeft: '0px'
            } : {})
          }, null, 8, ["checked", "style"])) : _ctx.type === 'checkbox' ? (_openBlock(), _createBlock(_component_ion_checkbox, {
            key: 7,
            checked: Boolean(_unref(value)),
            onIonChange: _cache[4] || (_cache[4] = e => value.value = e.detail.checked),
            slot: "end"
          }, null, 8, ["checked"])) : _ctx.type === 'datetime' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 8
          }, [(_props$opts3 = props.opts) !== null && _props$opts3 !== void 0 && _props$opts3.inline ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(AppDatetime, _mergeProps({
            opts: _ctx.opts,
            modelValue: _unref(value),
            disabled: _ctx.disabled
          }, {
            trigger: `app-form-field-item-${_ctx.field}`,
            "onUpdate:modelValue": safelyHandleDatetimeChange
          }), null, 16, ["trigger"])])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_ion_button, {
            slot: "end",
            fill: "clear"
          }, {
            default: _withCtx(() => {
              var _ctx$opts;
              return [_createVNode(_component_ion_icon, {
                icon: ((_ctx$opts = _ctx.opts) === null || _ctx$opts === void 0 ? void 0 : _ctx$opts.presentation) === 'time' ? 'time' : 'calendar',
                slot: "icon-only"
              }, null, 8, ["icon"])];
            }),
            _: 1
          }), _createVNode(AppDatetimePopover, _mergeProps({
            opts: _ctx.opts,
            modelValue: _unref(value)
          }, {
            trigger: `app-form-field-item-${_ctx.field}`,
            "onUpdate:modelValue": safelyHandleDatetimeChange
          }), null, 16, ["trigger"])], 64))], 64)) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_ion_text, {
            color: "medium",
            class: "help-text"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.helpText), 1)]),
            _: 1
          }, 512), [[_vShow, _ctx.helpText]]), _withDirectives(_createVNode(_component_ion_text, {
            color: "danger",
            class: "margin-align-center",
            slot: "end"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(errorMessage)), 1)]),
            _: 1
          }, 512), [[_vShow, !_ctx.hideErrorMsg && _unref(errorMessage)]]), _ctx.tooltipText ? (_openBlock(), _createBlock(AppIconTooltip, {
            key: 9,
            text: _ctx.tooltipText,
            slot: "end"
          }, null, 8, ["text"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "end")])];
        }),
        _: 3
      }, 16, ["id", "data-vv-field", "button", "class", "disabled"]);
    };
  }
});